(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acabaram-de-chegar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.adc').forEach(function (section) {
      var slider = section.querySelector('.adc__slider');
      var btnPrev = section.querySelector('.adc__arrow--prev');
      var btnNext = section.querySelector('.adc__arrow--next');
      if (!slider || !btnPrev || !btnNext) return;

      function getScrollAmount() {
        var item = slider.querySelector('.adc__item');
        return item ? item.offsetWidth + 20 : 260;
      }

      function updateButtons() {
        btnPrev.disabled = slider.scrollLeft <= 4;
        btnNext.disabled = slider.scrollLeft + slider.offsetWidth >= slider.scrollWidth - 4;
      }

      btnPrev.addEventListener('click', function () {
        slider.scrollBy({ left: -getScrollAmount() * 2, behavior: 'smooth' });
      });

      btnNext.addEventListener('click', function () {
        slider.scrollBy({ left: getScrollAmount() * 2, behavior: 'smooth' });
      });

      slider.addEventListener('scroll', updateButtons, { passive: true });
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  const MOBILE_BP = 768;

  function initCarousel(section) {
    const track = section.querySelector('.benefits-bar__inner');
    const dotsEl = section.querySelector('.benefits-bar__dots');
    if (!track || !dotsEl) return;

    function isMobile() { return window.innerWidth <= MOBILE_BP; }

    function buildDots() {
      dotsEl.innerHTML = '';
      if (!isMobile()) return;

      const items = track.querySelectorAll('.benefits-bar__item');
      const pages = Math.ceil(items.length / 2);

      for (let i = 0; i < pages; i++) {
        const dot = document.createElement('span');
        dot.className = 'dot' + (i === 0 ? ' active' : '');
        dot.addEventListener('click', function () {
          const itemWidth = track.querySelector('.benefits-bar__item').offsetWidth;
          track.scrollTo({ left: i * itemWidth * 2, behavior: 'smooth' });
        });
        dotsEl.appendChild(dot);
      }
    }

    function updateDots() {
      if (!isMobile()) return;
      const dots = dotsEl.querySelectorAll('.dot');
      if (!dots.length) return;
      const itemWidth = track.querySelector('.benefits-bar__item')?.offsetWidth || 1;
      const page = Math.round(track.scrollLeft / (itemWidth * 2));
      dots.forEach(function (d, i) { d.classList.toggle('active', i === page); });
    }

    buildDots();
    track.addEventListener('scroll', updateDots, { passive: true });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(buildDots, 150);
    });
  }

  function initAll() {
    document.querySelectorAll('.benefits-bar[data-section-id]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.bs').forEach(function (section) {
      var slider = section.querySelector('.bs__slider');
      var btnPrev = section.querySelector('.bs__arrow--prev');
      var btnNext = section.querySelector('.bs__arrow--next');
      if (!slider || !btnPrev || !btnNext) return;

      function getScrollAmount() {
        var item = slider.querySelector('.bs__item');
        return item ? item.offsetWidth + 20 : 260;
      }

      function updateButtons() {
        btnPrev.disabled = slider.scrollLeft <= 4;
        btnNext.disabled = slider.scrollLeft + slider.offsetWidth >= slider.scrollWidth - 4;
      }

      btnPrev.addEventListener('click', function () {
        slider.scrollBy({ left: -getScrollAmount() * 2, behavior: 'smooth' });
      });

      btnNext.addEventListener('click', function () {
        slider.scrollBy({ left: getScrollAmount() * 2, behavior: 'smooth' });
      });

      slider.addEventListener('scroll', updateButtons, { passive: true });
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-news"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-blog-news]');
    if (!section) return;

    var wpUrl = section.dataset.wpUrl || 'https://blog.syma.com.br';
    var limit = parseInt(section.dataset.limit || '3', 10);
    var blogUrl = section.dataset.blogUrl || wpUrl.replace(/\/wp-json.*$/, '');
    var showViewAll = section.dataset.viewAll === 'true';
    var title = section.dataset.title || 'Conteudo & Dicas';
    var loadingText = section.dataset.loading || 'Carregando...';
    var errorText = section.dataset.error || 'Não foi possível carregar os posts.';

    var grid = section.querySelector('[data-posts-grid]');
    var loadingEl = section.querySelector('[data-loading-el]');
    var errorEl = section.querySelector('[data-error-el]');
    var titleEl = section.querySelector('[data-title-el]');
    var viewAllLink = section.querySelector('[data-view-all-link]');

    if (titleEl) titleEl.textContent = title;
    if (loadingEl) {
      var span = loadingEl.querySelector('.blog-news__loading-text');
      if (span) span.textContent = loadingText;
    }

    var MONTHS = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];

    var apiUrl = wpUrl.replace(/\/?$/, '') + '/wp-json/wp/v2/posts?per_page=' + limit + '&_embed';

    function stripHtml(html) {
      if (!html) return '';
      var tmp = document.createElement('div');
      tmp.innerHTML = html.replace(/&hellip;/g, '...').replace(/&nbsp;/g, ' ');
      return tmp.textContent || tmp.innerText || '';
    }

    function escapeHtml(str) {
      if (!str) return '';
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function isSafeUrl(url) {
      return url && (url.indexOf('http://') === 0 || url.indexOf('https://') === 0);
    }

    function formatDate(dateStr) {
      var d = new Date(dateStr);
      if (isNaN(d)) return '';
      return d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
    }

    function readingTime(html) {
      if (!html) return 1;
      var words = stripHtml(html).split(/\s+/).filter(Boolean).length;
      return Math.max(1, Math.round(words / 200));
    }

    function renderPost(post) {
      var media = post._embedded && post._embedded['wp:featuredmedia'] && post._embedded['wp:featuredmedia'][0];
      var imgUrl = media && isSafeUrl(media.source_url) ? media.source_url : '';
      var postTitle = escapeHtml(post.title && post.title.rendered ? post.title.rendered : '');
      var excerpt = escapeHtml(stripHtml(post.excerpt && post.excerpt.rendered ? post.excerpt.rendered : ''));
      var link = isSafeUrl(post.link) ? post.link : blogUrl;
      var dateStr = formatDate(post.date);
      var mins = readingTime(post.content && post.content.rendered ? post.content.rendered : '');

      var terms = post._embedded && post._embedded['wp:term'] && post._embedded['wp:term'][0];
      var tag = terms && terms[0] && terms[0].name ? escapeHtml(terms[0].name.toUpperCase()) : '';

      var card = document.createElement('article');
      card.className = 'article-card';
      card.innerHTML =
        '<a href="' + link + '" class="article-card__link" target="_blank" rel="noopener">' +
          '<div class="article-card__image-wrap">' +
            (imgUrl ? '<img src="' + imgUrl + '" alt="' + postTitle + '" class="article-card__image" loading="lazy">' : '') +
          '</div>' +
          '<div class="article-card__body">' +
            (tag ? '<span class="article-card__tag">' + tag + '</span>' : '') +
            '<h3 class="article-card__title">' + postTitle + '</h3>' +
            '<p class="article-card__excerpt">' + excerpt + '</p>' +
            '<div class="article-card__meta">' +
              '<span>' + dateStr + '</span>' +
              '<span class="article-card__meta-dot"></span>' +
              '<span>' + mins + ' min</span>' +
            '</div>' +
            '<a href="' + link + '" class="article-card__read-more" target="_blank" rel="noopener">Ler Mais &rarr;</a>' +
          '</div>' +
        '</a>';
      return card;
    }

    fetch(apiUrl)
      .then(function(res) { return res.ok ? res.json() : Promise.reject(new Error('API error')); })
      .then(function(posts) {
        if (loadingEl) loadingEl.remove();
        if (errorEl) errorEl.style.display = 'none';
        if (showViewAll && viewAllLink) {
          viewAllLink.href = blogUrl;
          viewAllLink.style.display = '';
        }
        if (Array.isArray(posts) && posts.length > 0) {
          posts.forEach(function(post) { grid.appendChild(renderPost(post)); });
        }
      })
      .catch(function() {
        if (loadingEl) loadingEl.remove();
        if (errorEl) {
          var p = errorEl.querySelector('.blog-news__error-text');
          if (p) p.textContent = errorText;
          errorEl.style.display = 'block';
        }
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
(function () {
  'use strict';

  var wrapper  = document.getElementById('cart-items-wrapper');
  var subtotal = document.getElementById('cart-subtotal-value');
  var total    = document.getElementById('cart-total-value');

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return 'R$\u00a0' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function setLoading(on) {
    if (!wrapper) return;
    if (on) wrapper.classList.add('is-loading');
    else wrapper.classList.remove('is-loading');
  }

  function updateTotals(cart) {
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (total)    total.textContent    = formatMoney(cart.total_price);

    /* update cart badge in header */
    var badge = document.querySelector('.header-main__cart-count');
    if (badge) {
      if (cart.item_count > 0) badge.textContent = cart.item_count;
      else badge.remove();
    }

    /* dispatch global cart event so the drawer also updates */
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function removeRow(line) {
    var row = document.querySelector('.cart-page__item[data-line="' + line + '"]');
    if (row) {
      row.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
      row.style.opacity = '0';
      row.style.transform = 'translateX(-8px)';
      setTimeout(function () { row.remove(); checkEmpty(); }, 260);
    }
  }

  function checkEmpty() {
    var list  = document.getElementById('cart-items-list');
    var page  = document.getElementById('cart-page');
    if (!list || !page) return;
    if (list.children.length === 0) {
      /* reload to show empty state rendered by Liquid */
      window.location.reload();
    }
  }

  function updateQtyDisplay(line, qty) {
    var row    = document.querySelector('.cart-page__item[data-line="' + line + '"]');
    if (!row) return;
    var display = row.querySelector('[data-quantity-display]');
    var decBtn  = row.querySelector('[data-cart-decrease]');
    var incBtn  = row.querySelector('[data-cart-increase]');
    if (display) display.textContent = qty;
    if (decBtn) {
      decBtn.dataset.quantity = qty - 1;
      decBtn.disabled = qty <= 1;
    }
    if (incBtn) incBtn.dataset.quantity = qty + 1;
  }

  function changeQuantity(line, qty) {
    setLoading(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      setLoading(false);
      if (qty === 0) {
        removeRow(line);
      } else {
        updateQtyDisplay(line, qty);
        /* update line price */
        var row = document.querySelector('.cart-page__item[data-line="' + line + '"]');
        if (row) {
          var linePrice = row.querySelector('[data-line-price] .cart-page__item-price-final');
          if (linePrice && cart.items[line - 1]) {
            linePrice.textContent = formatMoney(cart.items[line - 1].final_line_price);
          }
        }
      }
      updateTotals(cart);

    })
    .catch(function (err) {
      console.error('Cart error:', err);
      setLoading(false);
    });
  }

  /* ── Event delegation ── */
  var page = document.getElementById('cart-page');
  if (!page) return;

  page.addEventListener('click', function (e) {
    var inc    = e.target.closest('[data-cart-increase]');
    var dec    = e.target.closest('[data-cart-decrease]');
    var remove = e.target.closest('[data-cart-remove]');

    if (inc) {
      var line = parseInt(inc.dataset.cartIncrease, 10);
      var qty  = parseInt(inc.dataset.quantity, 10);
      changeQuantity(line, qty);
    } else if (dec) {
      var line = parseInt(dec.dataset.cartDecrease, 10);
      var qty  = parseInt(dec.dataset.quantity, 10);
      if (qty >= 0) changeQuantity(line, qty);
    } else if (remove) {
      var line = parseInt(remove.dataset.cartRemove, 10);
      changeQuantity(line, 0);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    /* ── Drawer de filtros (mobile) ── */
    var filterOpenBtn  = document.getElementById('collection-filter-open');
    var filterSidebar  = document.getElementById('collection-sidebar');
    var filterBackdrop = document.getElementById('collection-filter-backdrop');
    var filterCloseBtn = document.getElementById('collection-filter-close-mobile');

    function openFilterDrawer() {
      if (!filterSidebar) return;
      filterSidebar.classList.add('collection-page__sidebar--open');
      if (filterBackdrop) {
        filterBackdrop.style.display = 'block';
        requestAnimationFrame(function() {
          filterBackdrop.classList.add('collection-page__filter-backdrop--active');
        });
      }
      if (filterOpenBtn) filterOpenBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeFilterDrawer() {
      if (!filterSidebar) return;
      filterSidebar.classList.remove('collection-page__sidebar--open');
      if (filterBackdrop) {
        filterBackdrop.classList.remove('collection-page__filter-backdrop--active');
        filterBackdrop.addEventListener('transitionend', function handler() {
          filterBackdrop.style.display = '';
          filterBackdrop.removeEventListener('transitionend', handler);
        });
      }
      if (filterOpenBtn) filterOpenBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (filterOpenBtn)  filterOpenBtn.addEventListener('click', openFilterDrawer);
    if (filterCloseBtn) filterCloseBtn.addEventListener('click', closeFilterDrawer);
    if (filterBackdrop) filterBackdrop.addEventListener('click', closeFilterDrawer);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && filterSidebar && filterSidebar.classList.contains('collection-page__sidebar--open')) {
        closeFilterDrawer();
      }
    });
  })();

  (function() {
    var CHEVRON_SVG = '<svg class="faq-summary__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';

    function fixFaqItems() {
      document.querySelectorAll('.faq-item details').forEach(function(details) {
        var h3 = details.querySelector('h3');
        var faqP = details.querySelector('.faq-content') || details.querySelector('p');
        if (!h3) return;

        var title = h3.textContent.trim();
        var bodyHTML = faqP ? faqP.innerHTML : '';

        details.innerHTML =
          '<summary class="faq-summary"><span>' + title + '</span>' + CHEVRON_SVG + '</summary>' +
          '<div class="faq-body"><p>' + bodyHTML + '</p></div>';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixFaqItems);
    } else {
      fixFaqItems();
    }

    /* ── Hidrata demais páginas server-side (exceto a atual) para filtros client ── */
    (function() {
      var grid = document.getElementById('collection-grid');
      if (!grid) return;

      var serverPages = parseInt(grid.dataset.serverPages || '1', 10);
      var currentPage = parseInt(grid.dataset.currentPage || '1', 10);
      if (isNaN(currentPage) || currentPage < 1) currentPage = 1;

      if (serverPages <= 1) {
        grid.dataset.gridReady = '1';
        grid.dispatchEvent(new Event('grid:ready'));
        return;
      }

      var basePath = window.location.pathname;
      var baseParams = new URLSearchParams(window.location.search);
      baseParams.delete('page');
      // fa_* é filtro client-side — não envia no fetch (evita ruído e URLs enormes)
      Array.from(baseParams.keys()).forEach(function(k) {
        if (k.indexOf('fa_') === 0) baseParams.delete(k);
      });

      function fetchPage(p, attempt) {
        var qp = new URLSearchParams(baseParams.toString());
        qp.set('page', p);
        var qs = qp.toString();
        return fetch(basePath + (qs ? '?' + qs : ''))
          .then(function(r) {
            if (r.status === 429 && attempt < 3) {
              return new Promise(function(resolve) {
                setTimeout(function() {
                  resolve(fetchPage(p, attempt + 1));
                }, 600 * (attempt + 1));
              });
            }
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.text();
          })
          .then(function(html) {
            if (typeof html !== 'string') return html; // veio do retry já resolvido
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var items = Array.from(doc.querySelectorAll('#collection-grid .collection-page__grid-item'));
            var prods = [];
            try {
              var dataEl = doc.getElementById('syma-filter-data');
              if (dataEl) prods = JSON.parse(dataEl.textContent);
            } catch (e) {}
            return { page: p, items: items, products: prods };
          })
          .catch(function() { return { page: p, items: [], products: [] }; });
      }

      // Concorrência limitada — collections grandes (ex.: periféricos) estouravam 429
      var pages = [];
      for (var i = 1; i <= serverPages; i++) {
        if (i !== currentPage) pages.push(i);
      }
      var concurrency = 3;
      var groups = [];
      var idx = 0;

      function nextBatch() {
        if (idx >= pages.length) {
          return Promise.resolve();
        }
        var batch = pages.slice(idx, idx + concurrency);
        idx += concurrency;
        return Promise.all(batch.map(function(p) { return fetchPage(p, 0); }))
          .then(function(results) {
            groups = groups.concat(results);
            return nextBatch();
          });
      }

      nextBatch().then(function() {
        var byPage = {};
        byPage[currentPage] = Array.from(grid.querySelectorAll('.collection-page__grid-item'));
        groups.forEach(function(result) {
          byPage[result.page] = result.items;
        });

        var seen = {};
        var ordered = [];
        for (var p = 1; p <= serverPages; p++) {
          (byPage[p] || []).forEach(function(el) {
            var id = el.getAttribute('data-product-id');
            if (id && seen[id]) return;
            if (id) seen[id] = true;
            ordered.push(el);
          });
        }

        grid.innerHTML = '';
        ordered.forEach(function(el) {
          grid.appendChild(el.cloneNode(true));
        });

        var extraProducts = [];
        groups.forEach(function(result) {
          extraProducts = extraProducts.concat(result.products);
        });
        if (extraProducts.length) {
          grid.dispatchEvent(new CustomEvent('syma:products-extended', { detail: extraProducts }));
        }
        grid.dataset.gridReady = '1';
        grid.dispatchEvent(new Event('grid:ready'));
      });
    })();

    /* ── Contador de produtos: usa contagem real de disponíveis (não collection.products_count) ── */
    (function() {
      var grid = document.getElementById('collection-grid');
      var countEl = document.getElementById('collection-product-count');
      if (!grid || !countEl) return;

      var format = countEl.getAttribute('data-count-format') || '__COUNT__';

      function visibleCount() {
        var n = 0;
        grid.querySelectorAll('.collection-page__grid-item').forEach(function(el) {
          if (el.dataset.filterMatch === '0') return;
          n++;
        });
        return n;
      }

      function setCount(n) {
        countEl.textContent = format.replace('__COUNT__', n);
      }

      function onReady() {
        setCount(visibleCount());
      }

      if (grid.dataset.gridReady === '1') {
        onReady();
      } else {
        grid.addEventListener('grid:ready', onReady, { once: true });
      }
      grid.addEventListener('syma:filter-applied', function() { setCount(visibleCount()); });
    })();

    /* ── Paginação client-side com URLs rastreáveis (?page=N) ── */
    (function() {
      var grid = document.getElementById('collection-grid');
      var paginationEl = document.getElementById('collection-pagination');
      var countEl = document.getElementById('collection-product-count');
      if (!grid) return;

      function initPagination() {
        var perPage = parseInt(grid.dataset.perPage, 10) || 16;
        var allItems = Array.from(grid.querySelectorAll('.collection-page__grid-item'));
        var currentPage = 1;

        // Items sem data-filter-match ainda (filtro não rodou) → todos elegíveis.
        function activeItems() {
          return allItems.filter(function(el) {
            if (el.dataset.filterMatch === '0') return false;
            return true;
          });
        }

        function getPageFromUrl() {
          var raw = new URLSearchParams(window.location.search).get('page');
          if (raw === null || raw === '') return 1;
          var p = parseInt(raw, 10);
          if (isNaN(p) || p < 1) return 1;
          return p;
        }

        function buildPageUrl(page) {
          var params = new URLSearchParams(window.location.search);
          params.delete('page');
          if (page > 1) params.set('page', page);
          var qs = params.toString();
          return window.location.pathname + (qs ? '?' + qs : '');
        }

        function showPage(page, pushState) {
          // Releitura: hydrate pode ter trocado os nós do grid
          allItems = Array.from(grid.querySelectorAll('.collection-page__grid-item'));
          var filtered = activeItems();
          var totalPages = Math.ceil(filtered.length / perPage) || 1;
          var requested = parseInt(page, 10);
          if (isNaN(requested) || requested < 1) requested = 1;
          currentPage = Math.max(1, Math.min(requested, totalPages));
          var start = (currentPage - 1) * perPage;
          var end = start + perPage;

          // Esconde todos, mostra só a página atual dos filtrados
          allItems.forEach(function(el) { el.style.display = 'none'; });
          filtered.forEach(function(el, i) {
            if (i >= start && i < end) el.style.display = '';
          });

          renderPagination(totalPages);
          if (pushState) {
            history.pushState({ page: currentPage }, '', buildPageUrl(currentPage));
          } else if (requested !== currentPage) {
            // Clamp silencioso na URL (ex: ?page=999)
            history.replaceState({ page: currentPage }, '', buildPageUrl(currentPage));
          }
        }

        function renderPagination(totalPages) {
          if (!paginationEl) return;
          if (totalPages <= 1) { paginationEl.innerHTML = ''; return; }

          var parts = [];
          if (currentPage > 1) {
            parts.push('<a href="' + buildPageUrl(currentPage - 1) + '" class="page" data-p="' + (currentPage - 1) + '" aria-label="Anterior">«</a>');
          }
          for (var i = 1; i <= totalPages; i++) {
            var near = (i >= currentPage - 2 && i <= currentPage + 2);
            var edge = (i === 1 || i === totalPages);
            if (near || edge) {
              if (i === currentPage) {
                parts.push('<span class="page current">' + i + '</span>');
              } else {
                parts.push('<a href="' + buildPageUrl(i) + '" class="page" data-p="' + i + '">' + i + '</a>');
              }
            } else if (i === currentPage - 3 || i === currentPage + 3) {
              parts.push('<span class="page">…</span>');
            }
          }
          if (currentPage < totalPages) {
            parts.push('<a href="' + buildPageUrl(currentPage + 1) + '" class="page" data-p="' + (currentPage + 1) + '" aria-label="Próximo">»</a>');
          }
          paginationEl.innerHTML = parts.join('');
          paginationEl.querySelectorAll('[data-p]').forEach(function(link) {
            link.addEventListener('click', function(e) {
              e.preventDefault();
              showPage(parseInt(this.dataset.p, 10), true);
              // Depois do update do DOM — scrollIntoView em showPage cancelava este scroll
              window.scrollTo({ top: 0, behavior: 'smooth' });
            });
          });
        }

        window.addEventListener('popstate', function(e) {
          showPage(e.state && e.state.page ? e.state.page : getPageFromUrl(), false);
        });

        // Filtro mudou: buildUrl já remove ?page= → getPageFromUrl() = 1.
        // Reapply pós-hydrate preserva ?page=N da URL.
        grid.addEventListener('syma:filter-applied', function() {
          showPage(getPageFromUrl(), false);
        });

        if (allItems.length === 0) {
          grid.parentNode.insertAdjacentHTML('afterbegin', '<p class="collection-page__empty">Nenhum produto disponível nesta coleção.</p>');
        } else {
          var initialPage = getPageFromUrl();
          // Limpa ?page=1 da URL; clampa páginas inválidas via showPage
          history.replaceState({ page: initialPage }, '', buildPageUrl(initialPage));
          showPage(initialPage, false);
        }
      }

      var serverPages = parseInt(grid.dataset.serverPages || '1', 10);
      if (serverPages <= 1) {
        initPagination();
      } else {
        grid.addEventListener('grid:ready', initPagination, { once: true });
      }
    })();

    const sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        const params = new URLSearchParams(window.location.search);
        params.set('sort_by', this.value);
        params.delete('page');
        const qs = params.toString();
        window.location.href = window.location.pathname + (qs ? '?' + qs : '');
      });
    }

    const navSlider = document.querySelector('[data-collection-nav-slider]');
    if (navSlider) {
      const track = navSlider.querySelector('[data-nav-track]');
      const prev = navSlider.querySelector('[data-nav-prev]');
      const next = navSlider.querySelector('[data-nav-next]');
      if (track && prev && next) {
        const scrollAmount = () => {
          const slide = track.querySelector('.collection-page__nav-slide');
          return slide ? slide.offsetWidth + 16 : 106;
        };
        prev.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
        next.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["destaques"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.dk').forEach(function (section) {
      var slider = section.querySelector('.dk__slider');
      var btnPrev = section.querySelector('.dk__arrow--prev');
      var btnNext = section.querySelector('.dk__arrow--next');
      if (!slider || !btnPrev || !btnNext) return;

      function getScrollAmount() {
        var item = slider.querySelector('.dk__item');
        return item ? item.offsetWidth + 20 : 260;
      }

      function updateButtons() {
        btnPrev.disabled = slider.scrollLeft <= 4;
        btnNext.disabled = slider.scrollLeft + slider.offsetWidth >= slider.scrollWidth - 4;
      }

      btnPrev.addEventListener('click', function () {
        slider.scrollBy({ left: -getScrollAmount() * 2, behavior: 'smooth' });
      });

      btnNext.addEventListener('click', function () {
        slider.scrollBy({ left: getScrollAmount() * 2, behavior: 'smooth' });
      });

      slider.addEventListener('scroll', updateButtons, { passive: true });
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var toggle  = document.querySelector('.header-main__menu-toggle');
    var drawer  = document.getElementById('mob-drawer');
    var overlay = document.getElementById('mob-drawer-overlay');
    var closeBtn = document.getElementById('mob-drawer-close');

    if (!toggle || !drawer || !overlay) return;

    var openLabel  = toggle.getAttribute('aria-label');
    var closeLabel = '{{ "header.menu_close" | t }}';

    function getDrawerFocusables() {
      return Array.from(drawer.querySelectorAll('a, button, input'));
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-visible');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', closeLabel);
      document.documentElement.style.overflow = 'hidden';
      getDrawerFocusables().forEach(function(el) { el.removeAttribute('tabindex'); });
      setTimeout(function() {
        var first = drawer.querySelector('.mob-drawer__close, a, input');
        if (first) first.focus();
      }, 50);
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-visible');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', openLabel);
      document.documentElement.style.overflow = '';
      getDrawerFocusables().forEach(function(el) { el.setAttribute('tabindex', '-1'); });
      toggle.focus();
    }

    toggle.addEventListener('click', function() {
      drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
    });

    overlay.addEventListener('click', closeDrawer);
    closeBtn.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  })();

  (function() {
    document.querySelectorAll('[data-mob-nav-toggle]').forEach(function(btn) {
      var panelId = btn.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
      });
    });
  })();

  /* ── Predictive Search ─────────────────────────────────── */
  (function () {
    var DEBOUNCE_MS = 280;
    var MIN_CHARS = 2;
    var CHEVRON = '<svg class="ps-query__chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';

    function formatMoney(val) {
      if (val == null) return '';
      var n = typeof val === 'number' ? val / 100 : parseFloat(String(val).replace(/[^\d,.-]/g, '').replace(',', '.'));
      return isNaN(n) ? String(val) : new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n);
    }

    function thumbUrl(url) {
      if (!url) return null;
      return url.replace(/(\.(jpe?g|png|gif|webp))(\?|$)/i, '_200x$1$3');
    }

    function discountPct(price, compare) {
      if (!compare || !price || compare <= price) return 0;
      return Math.round((1 - price / compare) * 100);
    }

    function buildSearchUrl(query) {
      return '/search?q=' + encodeURIComponent(query)
        + '&type=product'
        + '&options%5Bunavailable_products%5D=hide';
    }

    function withUnavailableHidden(url) {
      if (!url) return url;
      if (url.indexOf('unavailable_products') !== -1) return url;
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      return url + sep + 'options%5Bunavailable_products%5D=hide';
    }

    function renderResults(dropdown, query, queries, products) {
      var hasP = products && products.length > 0;
      var searchUrl = buildSearchUrl(query);

      if (!queries.length && !hasP) {
        dropdown.innerHTML = '<p class="ps-status">Nenhum resultado para <strong>' + query + '</strong></p>';
        return;
      }

      var idx = 0;

      /* ── Left: query suggestions ── */
      var leftHtml = '<div class="ps-col ps-col--queries">'
        + '<span class="ps-col__header">Sugestões de busca:</span>';

      if (queries.length) {
        queries.forEach(function (q) {
          leftHtml += '<a class="ps-query" href="' + withUnavailableHidden(q.url) + '" role="option" data-ps-idx="' + (idx++) + '">'
            + CHEVRON
            + '<span class="ps-query__text">' + (q.styled_text || q.text) + '</span>'
            + '</a>';
        });
      } else {
        /* Fallback: show typed query as only suggestion */
        leftHtml += '<a class="ps-query" href="' + searchUrl + '" role="option" data-ps-idx="' + (idx++) + '">'
          + CHEVRON
          + '<span class="ps-query__text">' + query + '</span>'
          + '</a>';
      }
      leftHtml += '</div>';

      /* ── Right: product grid ── */
      var rightHtml = '<div class="ps-col ps-col--products">'
        + '<div class="ps-col__header-row">'
        + '<span class="ps-col__header">Produtos sugeridos:</span>'
        + '<span class="ps-hint">Pressione <kbd>enter</kbd> para buscar</span>'
        + '</div>';

      if (hasP) {
        rightHtml += '<div class="ps-products-grid">';
        products.forEach(function (p) {
          var img = thumbUrl(p.featured_image && p.featured_image.url);
          var priceRaw = p.price_min;
          var compareRaw = p.compare_at_price_max || p.compare_at_price_min;
          var priceFmt = formatMoney(priceRaw);
          var compareFmt = compareRaw && compareRaw > priceRaw ? formatMoney(compareRaw) : '';
          var pct = discountPct(priceRaw, compareRaw);

          rightHtml += '<a class="ps-product-card" href="' + p.url + '" role="option" data-ps-idx="' + (idx++) + '">'
            + '<div class="ps-product-card__img-wrap">'
            + (img ? '<img class="ps-product-card__img" src="' + img + '" alt="' + (p.featured_image.alt || p.title).replace(/"/g, '&quot;') + '" width="200" height="200" loading="lazy">' : '')
            + (pct > 0 ? '<span class="ps-product-card__badge">-' + pct + '%</span>' : '')
            + '</div>'
            + '<div class="ps-product-card__info">'
            + '<span class="ps-product-card__name">' + p.title + '</span>'
            + (compareFmt ? '<span class="ps-product-card__price-original">' + compareFmt + '</span>' : '')
            + (priceFmt ? '<span class="ps-product-card__price">' + priceFmt + '</span>' : '')
            + '</div>'
            + '</a>';
        });
        rightHtml += '</div>';
      } else {
        rightHtml += '<p class="ps-status" style="text-align:left;padding:.5rem 0">Sem produtos encontrados</p>';
      }
      rightHtml += '</div>';

      var footer = '<a class="ps-footer" href="' + searchUrl + '">Veja todos os resultados para <strong>' + query + '</strong></a>';

      dropdown.innerHTML = '<div class="ps-body">' + leftHtml + rightHtml + '</div>' + footer;
    }

    function initPredictiveSearch(wrap) {
      var input = wrap.querySelector('input[type="search"]');
      var dropdown = wrap.querySelector('.ps-dropdown');
      if (!input || !dropdown) return;

      var timer = null;
      var activeIndex = -1;
      var abortCtrl = null;

      function getItems() {
        return Array.from(dropdown.querySelectorAll('[role="option"]'));
      }

      function setActive(index) {
        getItems().forEach(function (el, i) {
          var on = i === index;
          el.classList.toggle('ps-query--active', on && el.classList.contains('ps-query'));
          el.classList.toggle('ps-product-card--active', on && el.classList.contains('ps-product-card'));
        });
        activeIndex = index;
      }

      function open() { dropdown.hidden = false; input.setAttribute('aria-expanded', 'true'); }
      function close() { dropdown.hidden = true; input.setAttribute('aria-expanded', 'false'); activeIndex = -1; }

      function doFetch(query) {
        if (abortCtrl) abortCtrl.abort();
        abortCtrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var url = '/search/suggest.json'
          + '?q=' + encodeURIComponent(query)
          + '&resources[type]=product,query'
          + '&resources[limit]=6'
          + '&resources[options][unavailable_products]=hide'
          + '&resources[options][prefix]=last'
          + '&resources[options][fields]=title,product_type,variants.sku,variants.title,vendor,tag,body';
        var opts = abortCtrl ? { signal: abortCtrl.signal } : {};
        dropdown.innerHTML = '<p class="ps-status">Buscando\u2026</p>';
        open();
        window.fetch(url, opts)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var res = (data.resources && data.resources.results) || {};
            renderResults(dropdown, query, res.queries || [], res.products || []);
          })
          .catch(function () {});
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < MIN_CHARS) { close(); return; }
        timer = setTimeout(function () { doFetch(q); }, DEBOUNCE_MS);
      });

      input.addEventListener('keydown', function (e) {
        var items = getItems();
        if (dropdown.hidden || !items.length) return;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          setActive(Math.min(activeIndex + 1, items.length - 1));
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          var n = Math.max(activeIndex - 1, -1);
          setActive(n);
          if (n === -1) input.focus();
        } else if (e.key === 'Enter' && activeIndex >= 0) {
          e.preventDefault();
          items[activeIndex].click();
        } else if (e.key === 'Escape') {
          close(); input.blur();
        }
      });

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) close();
      });
    }

    document.querySelectorAll('[data-predictive-search]').forEach(initPredictiveSearch);
  })();

  (function() {
    var AUTOPLAY_MS = 7000;
    var mq = window.matchMedia('(max-width: 768px)');
    var items = Array.from(document.querySelectorAll('#header-banners-inner .header-banners__item'));
    if (items.length < 2) return;

    var current = 0;
    var timer = null;

    function showItem(index) {
      items.forEach(function(el, i) {
        el.classList.toggle('header-banners__item--active', i === index);
      });
    }

    function next() {
      current = (current + 1) % items.length;
      showItem(current);
    }

    function startCarousel() {
      showItem(current);
      timer = setInterval(next, AUTOPLAY_MS);
    }

    function stopCarousel() {
      clearInterval(timer);
      timer = null;
      items.forEach(function(el) {
        el.classList.remove('header-banners__item--active');
        el.style.display = '';
      });
    }

    function onBreakpointChange(e) {
      if (e.matches) {
        startCarousel();
      } else {
        stopCarousel();
      }
    }

    mq.addEventListener('change', onBreakpointChange);
    if (mq.matches) startCarousel();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const slider = document.querySelector('[data-hero-slider]');
    if (!slider) return;

    const slides = slider.querySelectorAll('[data-hero-slide]');
    const dots = document.querySelectorAll('[data-hero-dot]');
    const prevBtn = document.querySelector('[data-hero-prev]');
    const nextBtn = document.querySelector('[data-hero-next]');

    let currentIndex = 0;

    function goToSlide(index) {
      currentIndex = (index + slides.length) % slides.length;
      slides.forEach((s, i) => {
        s.classList.toggle('hero-banner__slide--active', i === currentIndex);
        s.setAttribute('aria-hidden', i !== currentIndex);
      });
      dots.forEach((d, i) => d.classList.toggle('hero-banner__dot--active', i === currentIndex));
    }

    if (prevBtn) prevBtn.addEventListener('click', () => goToSlide(currentIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goToSlide(currentIndex + 1));
    dots.forEach((d, i) => d.addEventListener('click', () => goToSlide(i)));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const prose = document.querySelector('[data-seo-prose]');
    const toggle = document.querySelector('[data-seo-toggle]');
    if (!prose || !toggle) return;

    const children = Array.from(prose.children).filter(el => el.tagName !== 'SCRIPT');
    if (children.length <= 2) { toggle.hidden = true; return; }

    const extra = document.createElement('div');
    extra.className = 'info-text__extra';
    children.slice(2).forEach(el => extra.appendChild(el));
    prose.appendChild(extra);

    toggle.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      extra.classList.toggle('info-text__extra--open', !expanded);
      const label = this.querySelector('[data-toggle-label]');
      if (label) label.textContent = expanded ? this.dataset.more : this.dataset.less;
      const icon = this.querySelector('[data-toggle-icon]');
      if (icon) icon.style.transform = expanded ? '' : 'rotate(180deg)';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.prod-rec[data-product-id]');
    if (!section) return;

    var productId = section.dataset.productId;
    var track = section.querySelector('.prod-rec__track');
    var btnPrev = section.querySelector('.prod-rec__arrow--prev');
    var btnNext = section.querySelector('.prod-rec__arrow--next');
    var sortSelect = section.querySelector('[data-pdp-sort-select]');
    var productsCache = [];
    var arrowsBound = false;

    /* ── Formata centavos em moeda ── */
    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
      return 'R$\u00a0' + (cents / 100).toFixed(2).replace('.', ',');
    }

    /* ── Escapa HTML para evitar XSS ── */
    function esc(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    /* ── Redimensiona imagem via Shopify CDN ── */
    function imgSrc(url, size) {
      if (!url) return '';
      if (url.indexOf('//') === 0) url = 'https:' + url;
      return url.replace(/(\.(jpe?g|png|gif|webp))(\?|$)/i, '_' + size + 'x$1$3');
    }

    /* ── Monta HTML do card reutilizando classes do product-card ── */
    function cardHtml(p) {
      var src = imgSrc(p.featured_image, 400);
      var imgTag = src
        ? '<img src="' + src + '" alt="' + esc(p.title) + '" loading="lazy" class="product-card__image" width="400" height="400">'
        : '';

      var discount = (p.compare_at_price > p.price)
        ? Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price)
        : 0;

      var badge = discount > 0
        ? '<span class="product-card__badge product-card__badge--sale">' + discount + '% OFF</span>'
        : '';

      var priceHtml = discount > 0
        ? '<div class="product-card__price product-card__price--sale">' +
            '<span class="product-card__compare-price">' +
              '<span class="product-card__price-label-de">De</span> ' +
              formatMoney(p.compare_at_price) +
            '</span>' +
            '<span class="product-card__price-current">' +
              '<span class="product-card__price-label-por">Por</span> ' +
              formatMoney(p.price) +
            '</span>' +
          '</div>'
        : '<div class="product-card__price">' + formatMoney(p.price) + '</div>';

      var cartIcon = '<svg class="product-card__btn-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>' +
        '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>' +
        '</svg>';

      return '<article class="product-card prod-rec__card">' +
        '<a href="' + p.url + '" class="product-card__image-link">' +
          '<div class="product-card__image-wrap">' + imgTag + badge + '</div>' +
        '</a>' +
        '<div class="product-card__info">' +
          '<h3 class="product-card__title"><a href="' + p.url + '">' + esc(p.title) + '</a></h3>' +
          priceHtml +
          '<a href="' + p.url + '" class="product-card__btn">' + cartIcon + 'Ver produto</a>' +
        '</div>' +
      '</article>';
    }

    /* ── Atualiza estado das setas ── */
    function updateArrows() {
      var max = track.scrollWidth - track.clientWidth;
      btnPrev.disabled = track.scrollLeft <= 2;
      btnNext.disabled = track.scrollLeft >= max - 2;
    }

    /* ── Scroll por 2 cards ── */
    function scrollBy(dir) {
      var first = track.querySelector('.prod-rec__card');
      var step = first ? (first.offsetWidth + 16) * 2 : 480;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    function remountTrack(mode) {
      var sorter = window.SymaPdpSort;
      var sorted = sorter
        ? sorter.sortProducts(productsCache, mode)
        : productsCache.slice();
      track.innerHTML = sorted.map(cardHtml).join('');
      track.scrollLeft = 0;
      updateArrows();
    }

    function bindArrows() {
      if (arrowsBound) return;
      arrowsBound = true;
      track.addEventListener('scroll', updateArrows, { passive: true });
      btnPrev.addEventListener('click', function () { scrollBy(-1); });
      btnNext.addEventListener('click', function () { scrollBy(1); });
    }

    /* ── Fetch recomendações ── */
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=10')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        productsCache = (data.products || [])
          .filter(function (p) { return String(p.id) !== String(productId); })
          .slice(0, 8)
          .map(function (p, i) {
            p._index = i;
            return p;
          });

        if (!productsCache.length) return; /* sem resultados: seção permanece oculta */

        section.style.display = '';
        remountTrack(sortSelect ? sortSelect.value : 'best-selling');
        bindArrows();

        if (sortSelect) {
          sortSelect.addEventListener('change', function () {
            remountTrack(this.value);
          });
        }
      })
      .catch(function () { /* falha silenciosa — seção permanece oculta */ });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Tab navigation — Descrição / Especificações
  (function() {
    var tabsEl = document.querySelector('.product-page__tabs');
    if (!tabsEl) return;
    tabsEl.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-page__tab-btn');
      if (!btn) return;
      var tab = btn.dataset.tab;
      tabsEl.querySelectorAll('.product-page__tab-btn').forEach(function(b) { b.classList.remove('is-active'); });
      tabsEl.querySelectorAll('.product-page__tab-content').forEach(function(p) { p.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var panel = tabsEl.querySelector('[data-tab-panel="' + tab + '"]');
      if (panel) panel.classList.add('is-active');
    });
  })();

  (function() {
    const variantSelect = document.getElementById('product-variant');
    const variantsJson = document.getElementById('product-variants-json');
    const compareEl = document.querySelector('[data-compare]');
    const dePorEl = document.querySelector('[data-de-por]');
    const regularPriceEl = document.querySelector('[data-price-regular]');
    // Bloco de preço da PDP: carrega os dois fatores da cascata (módulo + extra do PIX).
    // Seletor por [data-product-price] — [data-pix-extra] também existe no minicart e no compre junto.
    const priceBlockEl = document.querySelector('[data-product-price][data-pix-extra]');
    const pixExtra = priceBlockEl ? (parseInt(priceBlockEl.getAttribute('data-pix-extra'), 10) || 0) : 5;
    const badgeDiscount = priceBlockEl ? (parseInt(priceBlockEl.getAttribute('data-badge-discount'), 10) || 0) : 0;
    const hasPromoBadge = badgeDiscount > 0;
    const productCompare = priceBlockEl ? (parseInt(priceBlockEl.getAttribute('data-product-compare'), 10) || 0) : 0;
    const installmentsEl = document.querySelector('[data-installments]');
    const availabilityEl = document.querySelector('[data-availability]');
    const metaEl = document.querySelector('[data-meta]');
    const addBtn = document.querySelector('[data-add-btn]');

    const formatMoney = function(cents) {
      return (cents / 100).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    };

    document.addEventListener('click', function(e) {
      var thumb = e.target.closest('.product-page__thumb');
      if (thumb) {
        var gallery = thumb.closest('[data-product-gallery]');
        if (!gallery) return;
        var mainImgWrap = gallery.querySelector('[data-product-main-image-wrap]');
        var mainImg = mainImgWrap ? mainImgWrap.querySelector('img') : null;
        var src = thumb.getAttribute('data-src');
        if (!mainImg || !src) return;
        gallery.querySelectorAll('.product-page__thumb').forEach(function(t) { t.classList.remove('product-page__thumb--active'); });
        thumb.classList.add('product-page__thumb--active');
        mainImg.removeAttribute('srcset');
        mainImg.src = src;
        return;
      }

      var navBtn = e.target.closest('[data-thumb-prev], [data-thumb-next]');
      if (navBtn) {
        var track = navBtn.closest('[data-thumbnails-slider]');
        if (!track) return;
        var scrollEl = track.querySelector('[data-thumbs-track]');
        if (!scrollEl) return;
        var scrollAmount = 80;
        if (navBtn.hasAttribute('data-thumb-prev')) {
          scrollEl.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        } else {
          scrollEl.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
      }
    });

    if (variantSelect && variantsJson) {
      const variants = JSON.parse(variantsJson.textContent);
      variantSelect.addEventListener('change', function() {
        const variantId = parseInt(this.value, 10);
        const variant = variants.find(function(v) { return v.id === variantId; });
        if (!variant) return;

        // Resolve o melhor compare disponível: variante tem prioridade, produto como fallback
        var compareRef = (variant.compare_at_price && variant.compare_at_price > variant.price)
          ? variant.compare_at_price
          : (productCompare > variant.price ? productCompare : 0);
        // Desconto do módulo que realmente se aplica a esta variante.
        // Espelho de snippets/promo-effective-discount.liquid — manter os dois idênticos.
        var effDiscount = badgeDiscount;
        if (badgeDiscount > 0 && compareRef > variant.price &&
            (compareRef - variant.price) * 100 > compareRef * badgeDiscount) {
          effDiscount = 0;
        }
        var promoSuppressed = badgeDiscount > 0 && effDiscount === 0;

        // Selo promocional da coleção: some quando o desconto do módulo não se aplica
        var promoBadgesEl = document.querySelector('.promo-badges--pdp');
        if (promoBadgesEl) promoBadgesEl.style.display = promoSuppressed ? 'none' : '';

        var discountBadgeEl = document.querySelector('[data-discount-badge]');
        if ((!hasPromoBadge || promoSuppressed) && compareRef > variant.price) {
          var discountPct = Math.floor((compareRef - variant.price) * 100 / compareRef);
          var offLabel = discountBadgeEl ? discountBadgeEl.textContent.replace(/^\d+/, '') : '% OFF';
          if (discountBadgeEl) {
            discountBadgeEl.textContent = discountPct + offLabel;
            discountBadgeEl.style.display = '';
          } else {
            var mainImgWrap = document.querySelector('[data-product-main-image-wrap]');
            if (mainImgWrap) {
              var newBadge = document.createElement('span');
              newBadge.className = 'product-page__discount-badge';
              newBadge.setAttribute('data-discount-badge', '');
              newBadge.textContent = discountPct + '% OFF';
              mainImgWrap.appendChild(newBadge);
            }
          }
        } else if (discountBadgeEl) {
          discountBadgeEl.style.display = 'none';
        }
        // Preço base: sempre o preço cheio da variante. Cascata igual ao checkout:
        // 1) desconto do módulo Shopify; 2) extra do PIX sobre o valor já descontado.
        var priceBase = variant.price;
        var promoPrice = Math.floor(priceBase * (100 - effDiscount) / 100);
        var pixPrice = Math.floor(promoPrice * (100 - pixExtra) / 100);
        document.querySelectorAll('[data-price]').forEach(function(el) {
          el.textContent = formatMoney(pixPrice);
        });

        // Selo "PIX x% OFF": o % efetivo muda por variante quando o módulo é suprimido.
        // Mesmo cálculo em décimos do Liquid: 1000 - (mult_modulo * mult_pix / 10).
        var pixEffTenths = 1000 - Math.floor((100 - effDiscount) * (100 - pixExtra) / 10);
        var pixEffInt = Math.floor(pixEffTenths / 10);
        var pixEffDec = pixEffTenths % 10;
        var pixEffText = pixEffDec > 0 ? pixEffInt + ',' + pixEffDec : String(pixEffInt);
        document.querySelectorAll('[data-pix-tag]:not([data-pix-tag-manual])').forEach(function(el) {
          if (pixEffTenths > 0) {
            el.textContent = 'PIX ' + pixEffText + '% OFF';
            el.style.display = '';
          } else {
            el.style.display = 'none';
          }
        });
        if (compareEl) {
          var deRef = compareRef > 0 ? compareRef : variant.price;
          if (deRef > 0) {
            compareEl.textContent = formatMoney(deRef);
            if (dePorEl) dePorEl.style.display = '';
            if (regularPriceEl) regularPriceEl.style.display = 'none';
          } else {
            if (dePorEl) dePorEl.style.display = 'none';
            if (regularPriceEl) regularPriceEl.style.display = '';
          }
        }
        var installmentsEls = document.querySelectorAll('[data-installments]');
        var installRulesEl = document.getElementById('installment-rules-json');
        if (installmentsEls.length && installRulesEl) {
          var installConfig = JSON.parse(installRulesEl.textContent);
          var minParcel = installConfig.min || 3000;
          var rules = installConfig.rules || [];
          var bestCount = 0, bestValue = 0, bestInterest = 0, bestTotal = 0;
          // Base do parcelamento: preço promocional (badge% sem PIX extra) quando badge ativo; preço cheio sem badge
          var installBase = (hasPromoBadge && effDiscount > 0) ? promoPrice : variant.price;
          rules.forEach(function(r) {
            var interestAmt = Math.floor(installBase * r.interest / 100);
            var total = installBase + interestAmt;
            var parcelValue = Math.floor(total / r.count);
            if (parcelValue >= minParcel) {
              bestCount = r.count;
              bestValue = parcelValue;
              bestInterest = r.interest;
              bestTotal = total;
            }
          });
          var installmentsParcel = document.querySelector('.product-page__price-parcel');
          if (bestCount >= 2) {
            var fmt = installmentsEls[0].getAttribute('data-installments-format') || 'Ou __TOTAL__ em até __COUNT__x de __VALUE__ sem juros';
            installmentsEls.forEach(function(el) {
              el.textContent = fmt.replace('__TOTAL__', formatMoney(bestTotal)).replace('__COUNT__', bestCount).replace('__VALUE__', formatMoney(bestValue));
            });
            if (installmentsParcel) installmentsParcel.style.display = '';
          } else {
            if (installmentsParcel) installmentsParcel.style.display = 'none';
          }
        }
        if (availabilityEl) {
          var inStock = availabilityEl.getAttribute('data-in-stock') || 'Em estoque';
          var outStock = availabilityEl.getAttribute('data-out-of-stock') || 'Esgotado';
          var textEl = availabilityEl.querySelector('[data-availability-text]');
          if (textEl) textEl.textContent = variant.available ? inStock : outStock;
          availabilityEl.className = 'product-page__availability product-page__availability--' + (variant.available ? 'in' : 'out');
          var iconEl = availabilityEl.querySelector('.product-page__availability-icon');
          if (variant.available && !iconEl) {
            var icon = document.createElement('span');
            icon.className = 'product-page__availability-icon';
            icon.setAttribute('aria-hidden', 'true');
            icon.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>';
            availabilityEl.insertBefore(icon, availabilityEl.firstChild);
          } else if (!variant.available && iconEl) {
            iconEl.remove();
          }
        }
        if (metaEl) {
          const skuSpan = metaEl.querySelector('[data-sku]');
          const skuLabel = metaEl.getAttribute('data-sku-label') || 'SKU';
          if (skuSpan) {
            if (variant.sku) {
              skuSpan.textContent = skuLabel + ': ' + variant.sku;
              skuSpan.style.display = '';
            } else {
              skuSpan.style.display = 'none';
            }
          }
        }
        var buyRow = document.querySelector('[data-buy-row]');
        var paymentButtons = document.querySelector('[data-payment-buttons]');
        var productPriceBlock = document.querySelector('[data-product-price]');
        var displayVal = variant.available ? '' : 'none';
        if (buyRow) buyRow.style.display = displayVal;
        if (paymentButtons) paymentButtons.style.display = displayVal;
        if (productPriceBlock) productPriceBlock.style.display = displayVal;
        if (addBtn) {
          addBtn.style.display = displayVal;
        }
        var mainImgEl = document.querySelector('[data-product-gallery] [data-product-main-image-wrap] img');
        if (mainImgEl) {
          var img = variant.featured_image || variant.image;
          if (img && img.src) {
            mainImgEl.setAttribute('src', img.src);
          }
        }
      });
    }

    const qtyInput = document.getElementById('product-quantity');
    const minusBtn = document.querySelector('[data-action="minus"]');
    const plusBtn = document.querySelector('[data-action="plus"]');

    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', function() {
        const v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, v - 1);
      });
    }
    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', function() {
        const v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
      });
    }

    // Compre junto: qty, preços dinâmicos, add to cart e comprar
    const cjSection = document.querySelector('[data-compre-junto-section]');
    if (cjSection) {
      var productPrice = parseInt(cjSection.getAttribute('data-product-price'), 10) || 0;
      const cjPrice = parseInt(cjSection.getAttribute('data-cj-price'), 10) || 0;
      // Cascata do bundle: cada produto já com o desconto do módulo; o extra do PIX incide sobre a soma
      const cjProductBadgeDiscount = parseInt(cjSection.getAttribute('data-product-badge-discount'), 10) || 0;
      const cjPromoPrice = parseInt(cjSection.getAttribute('data-cj-promo-price'), 10) || 0;
      const cjPixExtra = parseInt(cjSection.getAttribute('data-pix-extra'), 10) || 0;
      var productVariantId = parseInt(cjSection.getAttribute('data-product-variant'), 10);
      const cjVariantId = parseInt(cjSection.getAttribute('data-cj-variant'), 10);
      const cards = cjSection.querySelectorAll('[data-compre-junto-card]');
      const totalOrigEl = cjSection.querySelector('[data-total-orig]');
      const totalPixEl = cjSection.querySelector('[data-total-pix]');
      const addCartBtn = cjSection.querySelector('[data-compre-junto-add-cart]');
      const buyBtn = cjSection.querySelector('[data-compre-junto-buy]');

      function getQty(card) {
        const input = card.querySelector('[data-compre-junto-qty]');
        return input ? Math.max(1, parseInt(input.value, 10) || 1) : 1;
      }

      function updateTotals() {
        const qty1 = cards[0] ? getQty(cards[0]) : 1;
        const qty2 = cards[1] ? getQty(cards[1]) : 1;
        const totalOrig = productPrice * qty1 + cjPrice * qty2;
        const productPromoPrice = Math.floor(productPrice * (100 - cjProductBadgeDiscount) / 100);
        const totalPromo = productPromoPrice * qty1 + cjPromoPrice * qty2;
        const totalPix = Math.floor(totalPromo * (100 - cjPixExtra) / 100);
        if (totalOrigEl) totalOrigEl.textContent = formatMoney(totalOrig);
        if (totalPixEl) totalPixEl.textContent = formatMoney(totalPix);
      }

      cjSection.querySelectorAll('.cj-card__qty-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          const card = btn.closest('[data-compre-junto-card]');
          const input = card && card.querySelector('[data-compre-junto-qty]');
          if (!input) return;
          var v = parseInt(input.value, 10) || 1;
          if (btn.getAttribute('data-action') === 'minus') v = Math.max(1, v - 1);
          else v = v + 1;
          input.value = v;
          updateTotals();
        });
      });

      cjSection.querySelectorAll('[data-compre-junto-qty]').forEach(function(input) {
        input.addEventListener('change', function() {
          var v = parseInt(this.value, 10) || 1;
          this.value = Math.max(1, v);
          updateTotals();
        });
      });

      function addCompreJuntoToCart(goToCheckout) {
        const qty1 = cards[0] ? getQty(cards[0]) : 1;
        const qty2 = cards[1] ? getQty(cards[1]) : 1;
        const items = [
          { id: productVariantId, quantity: qty1 },
          { id: cjVariantId, quantity: qty2 }
        ];
        var btns = [addCartBtn, buyBtn];
        btns.forEach(function(b) { if (b) b.disabled = true; });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function(r) {
            return r.text().then(function(text) {
              var data;
              try { data = JSON.parse(text); } catch (e) { data = {}; }
              return { ok: r.ok, status: r.status, data: data };
            });
          })
          .then(function(result) {
            if (result.ok) {
              if (goToCheckout) {
                var checkoutUrl = cjSection.getAttribute('data-checkout-url') || '/checkout';
                window.location.href = checkoutUrl;
              } else {
                document.dispatchEvent(new CustomEvent('cart:openAfterAdd'));
              }
            } else {
              var msg = (result.data && result.data.description) || (result.data && result.data.message) || 'Erro ao adicionar';
              alert(msg);
            }
          })
          .catch(function(err) {
            console.error('Compre junto add to cart error:', err);
            alert('Erro ao adicionar ao carrinho. Tente novamente.');
          })
          .finally(function() {
            btns.forEach(function(b) { if (b) b.disabled = false; });
          });
      }

      cjSection.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-compre-junto-add-cart], [data-compre-junto-buy]');
        if (!btn) return;
        e.preventDefault();
        addCompreJuntoToCart(btn.hasAttribute('data-compre-junto-buy'));
      });

      if (variantSelect && variantsJson) {
        const variants = JSON.parse(variantsJson.textContent);
        variantSelect.addEventListener('change', function() {
          const v = variants.find(function(x) { return x.id === parseInt(variantSelect.value, 10); });
          if (v) {
            productVariantId = v.id;
            productPrice = v.price;
            updateTotals();
          }
        });
      }

      updateTotals();
    }
  })();

  /* ── Move bloco de cálculo de frete para abaixo das formas de pagamento ── */
  (function() {
    function moveFrete() {
      var freteBlock = document.querySelector('[id*="frete_no_produto"]');
      var anchor = document.querySelector('.product-page__payment-accordion');
      if (freteBlock && anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(freteBlock, anchor.nextSibling);
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', moveFrete);
    } else {
      moveFrete();
    }
  })();

  /* ── Slider + ordenação de produtos similares ── */
  (function() {
    var section = document.querySelector('[data-similar-slider]');
    if (!section) return;

    var track = section.querySelector('[data-similar-track]');
    var btnPrev = section.querySelector('[data-similar-prev]');
    var btnNext = section.querySelector('[data-similar-next]');
    var sortSelect = section.querySelector('[data-pdp-sort-select]');
    if (!track) return;

    function updateArrows() {
      if (!btnPrev || !btnNext) return;
      var max = track.scrollWidth - track.clientWidth;
      btnPrev.disabled = track.scrollLeft <= 2;
      btnNext.disabled = track.scrollLeft >= max - 2;
    }

    function scrollBy(dir) {
      var first = track.querySelector('.product-page__similar-item');
      var step = first ? (first.offsetWidth + 16) * 2 : 480;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    function remountSort(mode) {
      if (window.SymaPdpSort) {
        window.SymaPdpSort.sortElements(track, mode, '[data-pdp-sort-item]');
      }
      track.scrollLeft = 0;
      updateArrows();
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    if (btnPrev) btnPrev.addEventListener('click', function() { scrollBy(-1); });
    if (btnNext) btnNext.addEventListener('click', function() { scrollBy(1); });
    updateArrows();

    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        remountSort(this.value);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function() {
    /* ── Drawer de filtros (mobile) ── */
    var filterOpenBtn  = document.getElementById('collection-filter-open');
    var filterSidebar  = document.getElementById('collection-sidebar');
    var filterBackdrop = document.getElementById('collection-filter-backdrop');
    var filterCloseBtn = document.getElementById('collection-filter-close-mobile');

    function openFilterDrawer() {
      if (!filterSidebar) return;
      filterSidebar.classList.add('collection-page__sidebar--open');
      if (filterBackdrop) {
        filterBackdrop.style.display = 'block';
        requestAnimationFrame(function() {
          filterBackdrop.classList.add('collection-page__filter-backdrop--active');
        });
      }
      if (filterOpenBtn) filterOpenBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeFilterDrawer() {
      if (!filterSidebar) return;
      filterSidebar.classList.remove('collection-page__sidebar--open');
      if (filterBackdrop) {
        filterBackdrop.classList.remove('collection-page__filter-backdrop--active');
        filterBackdrop.addEventListener('transitionend', function handler() {
          filterBackdrop.style.display = '';
          filterBackdrop.removeEventListener('transitionend', handler);
        });
      }
      if (filterOpenBtn) filterOpenBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (filterOpenBtn)  filterOpenBtn.addEventListener('click', openFilterDrawer);
    if (filterCloseBtn) filterCloseBtn.addEventListener('click', closeFilterDrawer);
    if (filterBackdrop) filterBackdrop.addEventListener('click', closeFilterDrawer);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && filterSidebar && filterSidebar.classList.contains('collection-page__sidebar--open')) {
        closeFilterDrawer();
      }
    });

    /* ── Busca páginas server-side adicionais (buscas > 250 resultados) ── */
    (function() {
      var grid = document.getElementById('collection-grid');
      if (!grid) return;

      var serverPages = parseInt(grid.dataset.serverPages || '1', 10);
      if (serverPages <= 1) {
        grid.dataset.gridReady = '1';
        grid.dispatchEvent(new Event('grid:ready'));
        return;
      }

      var basePath = window.location.pathname;
      var baseParams = new URLSearchParams(window.location.search);
      baseParams.delete('page');
      Array.from(baseParams.keys()).forEach(function(k) {
        if (k.indexOf('fa_') === 0) baseParams.delete(k);
      });

      function fetchPage(p, attempt) {
        var qp = new URLSearchParams(baseParams.toString());
        qp.set('page', p);
        var qs = qp.toString();
        return fetch(basePath + (qs ? '?' + qs : ''))
          .then(function(r) {
            if (r.status === 429 && attempt < 3) {
              return new Promise(function(resolve) {
                setTimeout(function() {
                  resolve(fetchPage(p, attempt + 1));
                }, 600 * (attempt + 1));
              });
            }
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.text();
          })
          .then(function(html) {
            if (typeof html !== 'string') return html;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var items = Array.from(doc.querySelectorAll('#collection-grid .collection-page__grid-item'));
            var prods = [];
            try {
              var dataEl = doc.getElementById('syma-filter-data');
              if (dataEl) prods = JSON.parse(dataEl.textContent);
            } catch(e) {}
            return { items: items, products: prods };
          })
          .catch(function() { return { items: [], products: [] }; });
      }

      var pages = [];
      for (var i = 2; i <= serverPages; i++) pages.push(i);
      var concurrency = 3;
      var groups = [];
      var idx = 0;

      function nextBatch() {
        if (idx >= pages.length) return Promise.resolve();
        var batch = pages.slice(idx, idx + concurrency);
        idx += concurrency;
        return Promise.all(batch.map(function(p) { return fetchPage(p, 0); }))
          .then(function(results) {
            groups = groups.concat(results);
            return nextBatch();
          });
      }

      nextBatch().then(function() {
        var extraProducts = [];
        groups.forEach(function(result) {
          result.items.forEach(function(el) { grid.appendChild(el.cloneNode(true)); });
          extraProducts = extraProducts.concat(result.products);
        });
        if (extraProducts.length) {
          grid.dispatchEvent(new CustomEvent('syma:products-extended', { detail: extraProducts }));
        }
        grid.dataset.gridReady = '1';
        grid.dispatchEvent(new Event('grid:ready'));
      });
    })();

    /* ── Contador de produtos: usa contagem real de visíveis ── */
    (function() {
      var grid = document.getElementById('collection-grid');
      var countEl = document.getElementById('collection-product-count');
      if (!grid || !countEl) return;

      var format = countEl.getAttribute('data-count-format') || '__COUNT__';

      function visibleCount() {
        var n = 0;
        grid.querySelectorAll('.collection-page__grid-item').forEach(function(el) {
          if (el.dataset.filterMatch === '0') return;
          n++;
        });
        return n;
      }

      function setCount(n) {
        countEl.textContent = format.replace('__COUNT__', n);
      }

      function onReady() { setCount(visibleCount()); }

      if (grid.dataset.gridReady === '1') {
        onReady();
      } else {
        grid.addEventListener('grid:ready', onReady, { once: true });
      }
      grid.addEventListener('syma:filter-applied', function() { setCount(visibleCount()); });
    })();

    /* ── Paginação client-side com URLs rastreáveis (?page=N) ── */
    (function() {
      var grid = document.getElementById('collection-grid');
      var paginationEl = document.getElementById('collection-pagination');
      if (!grid) return;

      function initPagination() {
        var perPage = parseInt(grid.dataset.perPage, 10) || 20;
        var allItems = Array.from(grid.querySelectorAll('.collection-page__grid-item'));
        var currentPage = 1;

        function activeItems() {
          return allItems.filter(function(el) {
            if (el.dataset.filterMatch === '0') return false;
            return true;
          });
        }

        function getPageFromUrl() {
          var p = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
          return isNaN(p) ? 1 : Math.max(1, p);
        }

        function buildPageUrl(page) {
          var params = new URLSearchParams(window.location.search);
          params.delete('page');
          if (page > 1) params.set('page', page);
          var qs = params.toString();
          return window.location.pathname + (qs ? '?' + qs : '');
        }

        function showPage(page, pushState) {
          var filtered = activeItems();
          var totalPages = Math.ceil(filtered.length / perPage) || 1;
          currentPage = Math.max(1, Math.min(page, totalPages));
          var start = (currentPage - 1) * perPage;
          var end = start + perPage;

          allItems.forEach(function(el) { el.style.display = 'none'; });
          filtered.forEach(function(el, i) {
            if (i >= start && i < end) el.style.display = '';
          });

          renderPagination(totalPages);
          if (pushState) {
            history.pushState({ page: currentPage }, '', buildPageUrl(currentPage));
            grid.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }

        function renderPagination(totalPages) {
          if (!paginationEl) return;
          if (totalPages <= 1) { paginationEl.innerHTML = ''; return; }

          var parts = [];
          if (currentPage > 1) {
            parts.push('<a href="' + buildPageUrl(currentPage - 1) + '" class="page" data-p="' + (currentPage - 1) + '" aria-label="Anterior">«</a>');
          }
          for (var i = 1; i <= totalPages; i++) {
            var near = (i >= currentPage - 2 && i <= currentPage + 2);
            var edge = (i === 1 || i === totalPages);
            if (near || edge) {
              if (i === currentPage) {
                parts.push('<span class="page current">' + i + '</span>');
              } else {
                parts.push('<a href="' + buildPageUrl(i) + '" class="page" data-p="' + i + '">' + i + '</a>');
              }
            } else if (i === currentPage - 3 || i === currentPage + 3) {
              parts.push('<span class="page">…</span>');
            }
          }
          if (currentPage < totalPages) {
            parts.push('<a href="' + buildPageUrl(currentPage + 1) + '" class="page" data-p="' + (currentPage + 1) + '" aria-label="Próximo">»</a>');
          }
          paginationEl.innerHTML = parts.join('');
          paginationEl.querySelectorAll('[data-p]').forEach(function(link) {
            link.addEventListener('click', function(e) {
              e.preventDefault();
              showPage(parseInt(this.dataset.p, 10), true);
            });
          });
        }

        window.addEventListener('popstate', function(e) {
          showPage(e.state && e.state.page ? e.state.page : getPageFromUrl(), false);
        });

        grid.addEventListener('syma:filter-applied', function() {
          showPage(1, false);
        });

        if (allItems.length > 0) {
          history.replaceState({ page: getPageFromUrl() }, '', window.location.href);
          showPage(getPageFromUrl(), false);
        }
      }

      var serverPages = parseInt(grid.dataset.serverPages || '1', 10);
      if (serverPages <= 1) {
        initPagination();
      } else {
        grid.addEventListener('grid:ready', initPagination, { once: true });
      }
    })();

    /* O slider de faixa de preço (marca, atributos e "Limpar filtros") é
       renderizado e totalmente controlado por collection-filters.js. */
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["super-ofertas"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const carousel = document.querySelector('[data-super-ofertas-carousel]');
    if (!carousel) return;
    const track = carousel.querySelector('.super-ofertas__carousel-track');
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) return;

    const scrollAmount = () => {
      const slide = track.querySelector('.super-ofertas__carousel-slide');
      return slide ? slide.offsetWidth + 24 : 300;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    next.addEventListener('click', () => {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitrine-manual"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.vm').forEach(function (section) {
      var slider = section.querySelector('.vm__slider');
      var btnPrev = section.querySelector('.vm__arrow--prev');
      var btnNext = section.querySelector('.vm__arrow--next');
      if (!slider || !btnPrev || !btnNext) return;

      function getScrollAmount() {
        var item = slider.querySelector('.vm__item');
        return item ? item.offsetWidth + 20 : 260;
      }

      function updateButtons() {
        btnPrev.disabled = slider.scrollLeft <= 4;
        btnNext.disabled = slider.scrollLeft + slider.offsetWidth >= slider.scrollWidth - 4;
      }

      btnPrev.addEventListener('click', function () {
        slider.scrollBy({ left: -getScrollAmount() * 2, behavior: 'smooth' });
      });

      btnNext.addEventListener('click', function () {
        slider.scrollBy({ left: getScrollAmount() * 2, behavior: 'smooth' });
      });

      slider.addEventListener('scroll', updateButtons, { passive: true });
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
